import React from 'react';
import SapthahBanner2026 from '../images/Saptah-2026-10x4-1x.png';
import QRCode from '../images/qrcode.png';

const BhagavathaSaptahPage = () => {
    return (
        <div className="container mx-auto px-4 py-8 text-gray-800">
            <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
                <img
                    src={SapthahBanner2026}
                    alt="Sreemadh Bhagavatha Sapthaha Yajnam"
                    className="w-full h-72 md:h-96 object-cover"
                />

                <div className="p-6 md:p-10">
                    <h1 className="text-2xl md:text-4xl font-bold text-orange-700 text-center mb-4">
                        Sreemadh Bhagavatha Saptah Nyana Yajnam
                    </h1>

                    <p className="text-lg text-center text-gray-700 mb-8">
                        ശ്രീമദ് ഭാഗവത സപ്താഹ ജ്ഞാന യജ്ഞം
                    </p>

                    <div className="grid gap-6 md:grid-cols-2 text-base md:text-lg">
                        <div className="bg-orange-50 rounded-xl p-5">
                            <h2 className="font-bold text-orange-700 mb-3">Event Details</h2>
                            <ul className="space-y-2">
                                <li><strong>Date:</strong> 27.09.2026 to 03.10.2026</li>
                                <li><strong>Venue:</strong> Ayyappa Devasthanam, Kamalanagar, ECIL</li>
                                <li><strong>Season:</strong> കൊല്ലവർഷം 1202 കന്നി 11 - 17</li>
                                <li><strong>Program:</strong> Bhagavatha Sapthaha Nyana Yajnam</li>
                            </ul>
                        </div>

                        <div className="bg-orange-50 rounded-xl p-5">
                            <h2 className="font-bold text-orange-700 mb-3">Highlights</h2>
                            <ul className="space-y-2 list-disc pl-5">
                                <li>Discourses from the sacred Bhagavatha</li>
                                <li>Daily devotional chanting and prayers</li>
                                <li>Spiritual gathering for families and devotees</li>
                                <li>Encouraging bhakti, values, and harmony</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-10 bg-orange-50 border-l-4 border-orange-500 rounded-r-xl p-5">
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">
                            Dear Devotees
                        </p>
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">
                            The Annual Srimad Bhagavatha Saptaha Jnana Yagam is being organised from 27 September 2026 to 03 October 2026 at Sri Ayyappa Temple, Kamala Nagar,Hyderabad. We are blessed to have Sri Thrikodithanam Viswanathan as the Acharyan and the Acharya Varanam will be held on 26 September 2026.
                        </p>
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">
                            As you are all aware, this programme is a continuation of our spiritual and traditional activities, including the Karkidaka Vavu Bali, which was conducted in accordance with Hindu traditions and beliefs. The detailed Sapthaha programme information is available in our website  ramadharmapracharasabha.com  . The sacred tradition of Saptaha Sravana, listening to the Srimad Bhagavatham over seven days, provides a valuable opportunity for devotees to temporarily step away from the pressures and distractions of daily life and dedicate time to spiritual reflection, devotion, and inner enrichment.“Bhagavatha Sravana is not merely listening to sacred stories; it is a spiritual journey that inspires us to bring Bhakti, Dharma, and noble values into our daily lives.”
                        </p>
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">
                            We warmly invite you and your family to participate in the Srimad Bhagavatha Saptaha Jnana Yagnam and receive the divine blessings of Lord Maha Vishnu. Your presence, participation, and support mean a great deal to us. The devotees and well-wishers wholeheartedly supported our Karkidaka Vavu Bali, and we are confident that all will extend the same cooperation, encouragement, and support to make this sacred programme a grand success.
                        </p>
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">
                            Devotees who wish to support this noble spiritual programme through financial contributions may kindly use the QR code provided below. Those who would like to contribute in kind or through other forms of support may kindly contact the persons at the telephone numbers provided.
                        </p>
                        <p className="text-lg leading-relaxed text-gray-700 mb-3">

                            We sincerely look forward to your presence, participation, support, and prayers.<br/>
                            Thanking you in advance for your wholehearted cooperation and support.<br/><br/>

                            Om Namo Bhagavate Vasudevaya<br/><br/>
                            President | General Secretary | Treasurer
                        </p>
                    </div>
                    <div>
                        <h2 className="text-2xl md:text-4xl font-bold text-orange-700 text-center mb-4 mt-4">For Donations</h2>
                        <img src={QRCode} alt='QRCode - Donation for Saptah 2026' />
                    </div>

                    <div className="mt-8 flex justify-center">
                        <a
                            href="/events"
                            className="inline-block bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition"
                        >
                            Back to Events
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BhagavathaSaptahPage;
